import React, { useEffect, useRef, useState } from "react";
import styles from "./Dropdown.module.scss";

const ChevronIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
    <path
      d="M6 9l6 6 6-6"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Compact themed dropdown. Designed to be reusable (e.g. inside the
// react-datepicker custom header, or anywhere a small picker is needed).
const Dropdown = ({ value, options, onChange, ariaLabel }) => {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);
  const selected = options.find((o) => String(o.value) === String(value));

  useEffect(() => {
    if (!open) return undefined;
    const handleClickOutside = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    const handleKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKey);
    };
  }, [open]);

  return (
    <div className={styles?.headerDropdown} ref={wrapRef}>
      <button
        type="button"
        className={`${styles?.headerDropdownTrigger} ${open ? styles?.headerDropdownOpen : ""}`}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((p) => !p);
        }}
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label={ariaLabel}
      >
        <span className={styles?.headerDropdownLabel}>{selected?.label}</span>
        <span
          className={`${styles?.headerChevron} ${open ? styles?.chevronOpen : ""}`}
          aria-hidden
        >
          <ChevronIcon />
        </span>
      </button>
      {open && (
        <ul className={styles?.headerDropdownMenu} role="listbox">
          {options.map((o) => {
            const isSelected = String(o.value) === String(value);
            return (
              <li
                key={`${o.value}`}
                className={`${styles?.headerDropdownItem} ${isSelected ? styles?.headerDropdownItemSelected : ""}`}
                role="option"
                aria-selected={isSelected}
                onClick={(e) => {
                  e.stopPropagation();
                  onChange(o.value);
                  setOpen(false);
                }}
              >
                {o.label}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default Dropdown;
